import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
import tw from "tailwind-styled-components";
import { SCheckboxV2, SDropdownV3, SInput } from "../..";
import { SSlider } from "../../SSlider";
import { SButton, SField, SIcon } from "../../components";
import { useState, useEffect, useRef } from "react";
import { SWIconNodeSVGMap, SWIconNodeSVGCategories } from "../../editor-icons";
import { debounce, startCase } from "es-toolkit";
const DropdownWrapper = tw.div`
  px-3
  py-1
  bg-grayscale-dark
  rounded-md
  border border-white/10
`;
export const IconPropertyEditor = ({ value, onChangeValue, onClickValue, isDynamic, readOnly })=>{
    const setProps = (newProps)=>{
        const v = {
            name: typeof value?.name !== "undefined" ? value?.name : "Activity",
            strokeLinecap: typeof value?.strokeLinecap !== "undefined" ? value?.strokeLinecap : "round",
            strokeLinejoin: typeof value?.strokeLinejoin !== "undefined" ? value?.strokeLinejoin : "round",
            strokeColor: typeof value?.strokeColor !== "undefined" ? value?.strokeColor : "currentColor",
            strokeWidth: typeof value?.strokeWidth !== "undefined" ? value?.strokeWidth : 2,
            width: typeof value?.width !== "undefined" ? value?.width : 32,
            height: typeof value?.height !== "undefined" ? value?.height : 32,
            ...value,
            ...newProps
        };
        onChangeValue && onChangeValue({
            type: "property-icon",
            ...v
        });
    };
    const [searchValue, setSearchValue] = useState("");
    const [resetSelected, setResetSelected] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState("");
    const stringKeys = useMemo(()=>{
        return Object.keys(SWIconNodeSVGMap);
    }, []);
    const typeKeys = useMemo(()=>{
        return stringKeys.map((key)=>key);
    }, []);
    const categoryIconKeys = useMemo(()=>{
        return selectedCategory == "" ? stringKeys : stringKeys.filter((key)=>{
            return SWIconNodeSVGMap[key].categories.filter((c)=>c === selectedCategory).length > 0;
        });
    }, [
        selectedCategory
    ]);
    const [debouncedSearchValue, setDebouncedSearchValue] = useState(searchValue);
    // Debounce searchValue
    useEffect(()=>{
        const debouncer = debounce((newValue)=>{
            setDebouncedSearchValue(newValue);
        }, 300);
        debouncer(searchValue);
        return ()=>{
            debouncer.cancel();
        };
    }, [
        searchValue
    ]);
    const icons = useMemo(()=>{
        console.log(`[render] IconEditor`);
        const svgs = categoryIconKeys.filter((key)=>{
            return SWIconNodeSVGMap[key].tags.includes(debouncedSearchValue.toLowerCase().trim()) || key === value?.name || debouncedSearchValue.trim() == "";
        }).map((svg)=>svg).map((type)=>{
            return {
                type,
                element: SWIconNodeSVGMap[type].render({
                    style: {},
                    width: 24,
                    height: 24
                })
            };
        });
        // if searching, put the selected icon at the top
        if (debouncedSearchValue) {
            const selected = svgs.find((icon)=>icon.type === value?.name);
            if (selected) {
                svgs.splice(svgs.indexOf(selected), 1);
                svgs.unshift(selected);
            }
        }
        return svgs;
    }, [
        value?.name,
        debouncedSearchValue,
        categoryIconKeys
    ]);
    const iconButtons = useMemo(()=>{
        return icons.map((icon)=>{
            return /*#__PURE__*/ _jsx(SButton, {
                onClick: ()=>setProps({
                        name: icon.type
                    }),
                variant: icon.type === value?.name ? "primary" : "secondary",
                className: `!p-0 !m-0 flex items-center justify-center aspect-square rounded-md ${icon.type == value?.name ? "text-brand-primary" : "bg-grayscale-darker opacity-50 hover:bg-grayscale-light hover:text-white/100 transition"}`,
                children: icon.element
            }, icon.type);
        });
    }, [
        icons,
        value?.name
    ]);
    // TODO
    // useEffect(() => {
    //   if (searchValue) {
    //     setSearchValue("")
    //   }
    // }, [selectedNode?.id])
    const [visibleCount, setVisibleCount] = useState(64);
    const loadMoreRef = useRef(null);
    const iconGridRef = useRef(null);
    // // TODO
    // useEffect(() => {
    //   if (iconGridRef.current) {
    //     iconGridRef.current.scrollTop = 0
    //   }
    //   setVisibleCount(64)
    // }, [selectedCategory, searchValue, selectedNode?.id])
    useEffect(()=>{
        const observer = new IntersectionObserver((entries)=>{
            if (entries[0].isIntersecting) {
                setVisibleCount((prevCount)=>prevCount + 10) // Load 10 more items
                ;
            }
        }, {
            threshold: 1.0
        });
        if (loadMoreRef.current) {
            observer.observe(loadMoreRef.current);
        }
        return ()=>observer.disconnect();
    }, []);
    return /*#__PURE__*/ _jsx("div", {
        onClick: onClickValue,
        children: /*#__PURE__*/ _jsxs("div", {
            className: readOnly ? "pointer-events-none" : "",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: `grid grid-cols-[auto,1fr,auto,auto] items-center gap-0 justify-center px-3 border-t border-white/7 mt-3`,
                    children: [
                        searchValue !== "" ? /*#__PURE__*/ _jsx(SButton, {
                            isMinimal: true,
                            className: `!p-0 !m-0 transition relative`,
                            onClick: ()=>{
                                setSearchValue("");
                            },
                            children: /*#__PURE__*/ _jsx(SIcon, {
                                type: "x",
                                size: 14
                            })
                        }) : /*#__PURE__*/ _jsx(SIcon, {
                            type: "search",
                            className: `opacity-40`,
                            size: 14
                        }),
                        /*#__PURE__*/ _jsx(SInput, {
                            value: searchValue,
                            noMargin: true,
                            includeErrorPadding: false,
                            className: "!border-0  !px-1",
                            onChange: (e)=>{
                                setSearchValue(e.target.value);
                            },
                            placeholder: `Search ${icons.length.toLocaleString()} icons`
                        }),
                        /*#__PURE__*/ _jsx("span", {
                            className: "text-brand-primary",
                            children: /*#__PURE__*/ _jsx(SDropdownV3, {
                                value: {
                                    label: selectedCategory ? startCase(selectedCategory) : `All ${SWIconNodeSVGCategories.length}`,
                                    value: selectedCategory
                                },
                                onChange: (val)=>{
                                    setSelectedCategory(val.value);
                                },
                                options: [
                                    {
                                        label: `All ${SWIconNodeSVGCategories.length}`,
                                        value: ""
                                    },
                                    ...SWIconNodeSVGCategories.map((c)=>{
                                        return {
                                            label: startCase(c),
                                            value: c
                                        };
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(SField, {
                    children: /*#__PURE__*/ _jsxs("div", {
                        ref: iconGridRef,
                        className: "grid grid-cols-8 items-center gap-2  max-h-[274px] overflow-y-scroll border-y border-white/10 p-3",
                        children: [
                            iconButtons.slice(0, visibleCount),
                            /*#__PURE__*/ _jsx("div", {
                                ref: loadMoreRef,
                                style: {
                                    height: "20px"
                                }
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "grid grid-cols-[1fr,auto] py-0 gap-0 px-3 pb-0",
                    children: [
                        /*#__PURE__*/ _jsx(SCheckboxV2, {
                            value: value?.strokeLinecap === "round",
                            onChange: (val)=>{
                                setProps({
                                    strokeLinecap: val ? "round" : "butt",
                                    strokeLinejoin: val ? "round" : "miter"
                                });
                            },
                            children: "Rounded"
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "grid grid-cols-[auto,auto,1fr] items-center justify-start gap-2",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    children: "Stroke"
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "text-sm opacity-50 w-[18px]",
                                    children: `${value ? value.strokeWidth.toFixed(1) : 1.5}`
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "px-2",
                                    children: /*#__PURE__*/ _jsx(SSlider, {
                                        min: 1.0,
                                        max: 5,
                                        className: "!w-[170px]",
                                        step: 0.1,
                                        value: value?.strokeWidth || 1.5,
                                        onChange: (value)=>setProps({
                                                strokeWidth: value
                                            })
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
